export interface RoutePaginationState {
  pageIndex: number;
  pageSize: number;
}

export function toLimitOffset(pagination: RoutePaginationState): { limit: number; offset: number } {
  return {
    limit: pagination.pageSize,
    offset: pagination.pageIndex * pagination.pageSize,
  };
}

export function estimateUnknownTotalRowCount(
  pagination: RoutePaginationState,
  loadedRowCount: number,
): number {
  const offset = pagination.pageIndex * pagination.pageSize;
  return offset + loadedRowCount + (loadedRowCount === pagination.pageSize ? 1 : 0);
}

export function lastPageIndexForTotal(totalRowCount: number, pageSize: number): number {
  if (totalRowCount <= 0 || pageSize <= 0) {
    return 0;
  }
  return Math.max(0, Math.ceil(totalRowCount / pageSize) - 1);
}
